// extracted by mini-css-extract-plugin
export var dropdown = "_us-0";
export var imageWrapper = "_us-3";
export var itemNameContainer = "_us-1";
export var productImage = "_us-2";
export var spinnerWrapper = "_us-4";